import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from "react-router-dom";
import * as ROUTES from '../../../../constants/routes';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import { setCurrentSnagDetailWithFloorMeta, openUploadFilesModal } from '../../../../store/actions/projectActions';
import FutureMap from '../../../widgets/FutureMap';
import ViewAllFloorsModal from './ViewAllFloorsModal';
import ReactModal from 'react-modal';
import AddNewFloorModal from './AddNewFloorModal';
import DeleteFloorModal from './DeleteFloorModal';
import { openNewFloorModal } from '../../../../store/actions/floorActions';
import AddFilesModal from './AddFilesModal';
import { get } from 'lodash'
import ReportModal from '../../../../components/reportGeneration/ReportModal';
import { openNewReportModal } from '../../../../store/actions/projectActions';
import { archiveFloorFromProject, openArchiveFloorFromProjectModal } from '../../../../store/actions/floorActions';
import ReactPaginate from 'react-paginate';
import AddSegmentsAll from './AddSegmentsAll';
class AllFloorsCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showAddFloorModal: false,
            showUploadNewMap: false,
            showVisibleModal: false,
            showFloorDeleteModal: false,
            offset: 0,
            perFloorListName: 3,
            currentFloorListRow: 0,
            projectSegmentNameForSearch: '',
            showViewSegmmentModal: false,

        }
        this.handlePageClick = this
            .handlePageClick
            .bind(this);
    }

    /// README: Choose part to open
    chooseFloor = (snagDetail, floorid, floorMap) => {
        const flooridMap = { floorid: floorid };
        const floorMeta = { ...floorMap, ...flooridMap };
        this.props.setCurrentSnagDetailWithFloorMeta(snagDetail, floorMeta);
    }

    /// README: Compare to sort
    compare(a, b) {
        if ('dateCreated' in a && 'dateCreated' in b) {
            if (a.dateCreated && b.dateCreated) {
                if (a.dateCreated.seconds < b.dateCreated.seconds) {
                    return -1;
                }
                if (a.dateCreated.seconds > b.dateCreated.seconds) {
                    return 1;
                }
            }
        }
        return 0;
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num) => {
        switch (num) {
            case 0: {
                this.props.openNewFloorModal();
                this.setState({ showAddFloorModal: true });
                break;
            }
            case 1: {
                this.props.openUploadFilesModal();
                this.setState({ showUploadNewMap: true });
                break;
            }
            case 2: {
                this.setState({ showFloorDeleteModal: true });
                break;
            }
            case 3: {
                this.setState({
                    showViewSegmmentModal: true,

                })
                break;
            }
            default: {
                this.setState({ showAddFloorModal: false, showUploadNewMap: false, showFloorDeleteModal: false, });
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showAddFloorModal: false });
                break;
            }
            case 1: {
                this.setState({ showUploadNewMap: false });
                break;
            }
            case 2: {
                this.setState({ showFloorDeleteModal: false });
                break;
            }
            case 3: {
                this.setState({
                    showViewSegmmentModal: false
                })
                break;
            }
            default: {
                this.setState({ showAddFloorModal: false, showUploadNewMap: false, showFloorDeleteModal: false, });
            }
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenReportModal = () => {
        this.props.openNewReportModal();
        this.setState({ showVisibleModal: true, });
    }

    handleCloseReportModal = () => {
        this.setState({ showVisibleModal: false });
    }

    getFloorsMapData = () => {
        const { snagDetail, commonLabels } = this.props;
        const { drawings } = commonLabels;
        const data = Object.keys(snagDetail.floorsMap);
        const postData = 'floorsMap' in snagDetail ? Object.keys(snagDetail.floorsMap).length !== 0 ? this.checkValidSearch ? Object.values(snagDetail.floorsMap).sort(this.compare).filter(this.filterBySearch).slice(this.state.offset, this.state.offset + this.state.perFloorListName).map((val, i) => (
            <div key={i}>
                <li className="card p-2 m-2" style={{ borderRadius: '10px' }}>
                    <div className="d-flex" >
                        <div className="p-2 flex-fill" style={{ fontWeight: "bold" }}>{val.name}
                            <br />
                            {/* <p className="badge badge-pill  px-3" style={{ backgroundColor: `${alu.color[memberAccessLevel]}`, color: `${alu.textColor[memberAccessLevel]}`, textAlign: "start", fontSize: "10px", fontStyle: "italic" }}>
                    {alu.text[memberAccessLevel]}</p> */}
                        </div>
                        <div className="p-2 flex-fill">
                            <Link type="button" className="btn btn-outline-dark btn-sm float-right text-decoration-none" role="button" aria-pressed="true" to={{ pathname: `${ROUTES.IND_PROJECT_FLOOR_MAP_EDITOR}` }} onClick={() => this.chooseFloor(snagDetail, val.floorid, val)} style={{ color: "black", fontWeight: "bold", textDecoration: "underline", borderRadius: '10px' }}>
                                Open
                            </Link>

                        </div>
                    </div>
                </li>
            </div>
        )) : `No ${drawings} found` : `No ${drawings} found` : `No ${drawings} found`;

        this.setState({
            noOfFloorNameList: Math.ceil(data.length / this.state.perFloorListName),

            postData,
        });

    }

    handlePageClick = (e) => {
        const selectedPage = e.selected;
        const offset = selectedPage * this.state.perFloorListName;

        this.setState({
            currentFloorListRow: selectedPage,
            offset: offset,
        }, () => {
            this.getFloorsMapData();
        });

    };

    componentDidMount() {
        this.getFloorsMapData();
    }

    handleSearch = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    checkValidSearch = () => {
        const { projectSegmentNameForSearch } = this.state;
        return (projectSegmentNameForSearch === "" || projectSegmentNameForSearch.startsWith(" ")) === false;
    }

    filterBySearch = (s) => {
        const { projectSegmentNameForSearch } = this.state;
        var sname = `${s.name}`;
        return sname.toLowerCase().startsWith(projectSegmentNameForSearch.toLowerCase());
    }
    componentDidUpdate(prevProps) {
        const { snagDetail } = this.props;
        const data = Object.keys(snagDetail.floorsMap);
        if (data.length !== Object.keys(prevProps.snagDetail.floorsMap).length) {
            this.getFloorsMapData();
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenSegmentModal = () => {
        this.setState({ showFloorDeleteModal: true, },
            () => this.props.openArchiveFloorFromProjectModal()
        );
    }

    handleCloseSegmentModal = () => {
        this.setState({ showFloorDeleteModal: false });
    }


    render() {
        const {
            themeColors, alu, userData, snagDetail, modalStyles, project, floor, tagLimitReached, internalProjectMembersLimitReached, externalProjectMembersLimitReached, commonLabels,
            modalInfoTextStyle, modalWidth, modalTitleStyle
        } = this.props;
        // console.log(commonLabels)
        const { assetParts, assetPart, uassetParts, uassetPart, defectMarkers, drawing, drawings, aloneAssetPart } = commonLabels;
        const { isFloorCreated, fapiMessage, showFapiLoader, fapiIsDoneAndSent } = floor;
        const { isMoreFilesSynced, isReportCreated } = project;
        const { uid, employeeid } = userData;
        const { accessMap } = snagDetail;
        const { isCompanyInsider, createNewFloorAccess, uploadNewMapAccess } = alu;
        const ueid = uid + employeeid;
        var viewMoreFloors = <MDICONS.MapRounded />//'floorsMap' in snagDetail ? Object.keys(snagDetail.floorsMap).length !== 0 ? (<ViewAllFloorsModal />) : (<React.Fragment />) : (<React.Fragment />);
        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;

        const floorList = Object.values(snagDetail.floorsMap) ?? [];

        /// create relevant button based on access level
        var newFloorButton = createNewFloorAccess[accessLevel] ? (<button className="btn btn-dark btn-sm" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(0) }}>Add a {assetPart}</button>) : (<React.Fragment></React.Fragment>);
        var uploadNewMapButton = uploadNewMapAccess[accessLevel] ? (<button className="btn btn-flat btn-sm border-dark" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(1) }}>Upload new {drawing}</button>) : (<React.Fragment></React.Fragment>);
        var reportGenButton = isCompanyInsider[accessLevel] ? (<button className="btn btn-dark btn-sm" style={{ borderRadius: '10px' }} onClick={() => this.handleOpenReportModal()}>Generate report</button>) : (<React.Fragment></React.Fragment>);
        var newFloorButtonDisabled = createNewFloorAccess[accessLevel] ? (<button className="btn btn-dark btn-sm" disabled style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(0) }}>Add a {assetPart}</button>) : (<React.Fragment></React.Fragment>);
        var uploadNewMapButtonDisabled = uploadNewMapAccess[accessLevel] ? (<button className="btn btn-flat btn-sm border-dark" disabled style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenModal(1) }}>Upload new {drawing}</button>) : (<React.Fragment></React.Fragment>);
        var deleteButton = floorList.length === 0 ? <React.Fragment /> : uploadNewMapAccess[accessLevel] ? (<button className="btn btn-flat btn-sm border-dark" style={{ borderRadius: '10px' }} onClick={() => { this.handleOpenSegmentModal() }}><MDICONS.Delete /></button>) : (<React.Fragment></React.Fragment>);

        return (
            <div className="card p-2" style={{ borderRadius: '15px', overflow: 'auto' }}>
                <div className="card-header bg-white p-0 mx-2">
                    <div className="row">
                        <div className="col-8">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>{uassetParts}</p>
                        </div>
                        <div className="col-4">
                            {/* {viewMoreParts} */}
                        </div>
                    </div>
                    <p style={modalInfoTextStyle}>Open or create {assetParts}. A {assetPart} can be a floor, room, car's interior, or etc.</p>
                </div>
                <div className="card-body">

                    <div className="form-group text-left">
                        <input type="text" className="form-control" id="projectSegmentNameForSearch" placeholder="Search for a project segment" onChange={this.handleSearch} />

                        <div style={{ maxHeight: '300px', overflow: 'auto', marginTop: '10px' }}>
                            {snagDetail ? 'floorsMap' in snagDetail ? Object.keys(snagDetail.floorsMap).length !== 0 ? this.checkValidSearch ? Object.values(snagDetail.floorsMap).sort(this.compare).filter(this.filterBySearch).slice(0, 2).map((val, i) => {
                                return (
                                    <div key={i}>
                                        <li className="card p-2 m-2" style={{ borderRadius: '10px' }}>
                                            <div className="d-flex" >
                                                <div className="p-2 flex-fill" style={{ fontWeight: "bold" }}>{val.name}
                                                    <br />
                                                </div>
                                                <div className="p-2 flex-fill">
                                                    <Link type="button" className="btn btn-outline-dark btn-sm float-right text-decoration-none" role="button" aria-pressed="true" to={{ pathname: `${ROUTES.IND_PROJECT_FLOOR_MAP_EDITOR}` }} onClick={() => this.chooseFloor(snagDetail, val.floorid, val)} style={{ color: "black", fontWeight: "bold", textDecoration: "underline", borderRadius: '10px' }}>
                                                        Open
                                                    </Link>

                                                </div>
                                                <div className="p-2">
                                                    {deleteButton}
                                                </div>

                                            </div>
                                        </li>


                                        <ReactModal
                                            style={modalStyles}
                                            isOpen={this.state.showFloorDeleteModal && !fapiIsDoneAndSent === true}
                                            onRequestClose={() => { this.handleCloseSegmentModal() }}
                                            contentLabel="Delete Project"
                                            ariaHideApp={false}
                                        >
                                            <button className="close" onClick={() => { this.handleCloseSegmentModal() }}>
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <div className="dynamicModalContainer">
                                                <div className="dynamicModalSm">
                                                    <React.Fragment>
                                                        <p style={modalTitleStyle}>Confirm delete this {assetPart}?</p>
                                                        <p style={modalTitleStyle}>Warning:</p>
                                                        <p style={modalInfoTextStyle}>Please you must note that this will permenantly delete this {assetParts}.</p>
                                                        <br />

                                                        {!showFapiLoader ? <div className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} onClick={() => this.props.archiveFloorFromProject(userData, snagDetail, val)} >Confirm</div> : <button className="btn btn-danger btn-sm" style={{ float: "right", borderRadius: '7px' }} type="button" disabled>
                                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                            &nbsp; Deleting the {assetPart}...
                                                        </button>}
                                                    </React.Fragment>
                                                </div>
                                            </div>
                                        </ReactModal>





                                    </div>
                                )
                            }) : `No ${drawings} found` : `No ${drawings} found` : `No ${drawings} found` : `No ${drawings} found`}
                        </div>
                        <br />
                        <div className="d-flex justify-content-between">
                            <div className="btn btn-dark btn-sm" style={{ borderRadius: '9px' }} onClick={() => { this.handleOpenModal(3) }}>View all</div>
                            
                            {tagLimitReached || internalProjectMembersLimitReached || externalProjectMembersLimitReached ?
                                <div className="">
                                    {newFloorButtonDisabled}
                                </div>
                                :
                                <React.Fragment>
                                    <div className="">
                                        {newFloorButton}
                                    </div >

                                </React.Fragment>


                            }
                        </div>


                    </div>

                    {/* <div className="row row-cols row-cols-md-2 row-cols-lg-4 row-cols-xl-3">
                        {this.state.postData}
                    </div> */}
                    {/* <div className="d-flex justify-content-start row col col-12 mt-3 ml-4" >
                        {this.state.postData !== `No ${assetParts} found` ? <ReactPaginate
                            previousLabel={"«"}
                            nextLabel={"»"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={this.state.noOfFloorNameList}
                            marginPagesDisplayed={1} // after ... pages display
                            pageRangeDisplayed={4} //  before ... page dispaly
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} /> : <React.Fragment />}
                    </div> */}

                    {/* Buttons */}
                    {/* <div className="mt-5">
                        <div className="d-flex justify-content-between"> */}

                    {/* Not in use */}
                    {/* <div className="align-self-center ">
                                {reportGenButton}
                            </div> */}

                    {/* {tagLimitReached || internalProjectMembersLimitReached || externalProjectMembersLimitReached ?
                                <div className="align-self-center">
                                    {uploadNewMapButtonDisabled}&nbsp;
                                    {newFloorButtonDisabled}
                                </div>
                                :
                                <React.Fragment>
                                    <div className="align-self-center">
                                        {uploadNewMapButton}&nbsp;
                                        {newFloorButton}

                                        <div className="" style={{ marginTop: '15px', float: 'right' }}>{deleteButton}</div>
                                    </div >

                                </React.Fragment>


                            } */}
                    {/* </div>
                    </div> */}

                    {/* REACT MODALS */}
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showAddFloorModal && !isFloorCreated === true}
                        onRequestClose={() => { this.handleCloseModal(0) }}
                        contentLabel="Add new floor"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AddNewFloorModal snagDetail={snagDetail} drawing={drawing} assetPart={assetPart} assetParts={assetParts} uassetPart={uassetPart} uassetParts={uassetParts} />
                    </ReactModal>

                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showUploadNewMap && !isMoreFilesSynced === true}
                        onRequestClose={() => { this.handleCloseModal(1) }}
                        contentLabel="Upload new map"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(1) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AddFilesModal snagDetail={snagDetail} />
                    </ReactModal>

                    {/* <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showFloorDeleteModal}
                        onRequestClose={() => { this.handleCloseModal(2) }}
                        contentLabel="Floor delete modal"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(2) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <DeleteFloorModal />
                    </ReactModal> */}

                    {/* REPORT MODAL  */}
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showVisibleModal === true}
                        onRequestClose={() => { this.handleCloseReportModal() }}
                        contentLabel="report modal"
                        ariaHideApp={false}

                    >
                        <button className="close" onClick={() => { this.handleCloseReportModal() }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <ReportModal defectMarkers={defectMarkers} />
                    </ReactModal>

                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showViewSegmmentModal === true}
                        onRequestClose={() => { this.handleCloseModal(3) }}
                        content="view all segments"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(3) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AddSegmentsAll />

                    </ReactModal>

                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
        alu: state.alu,
        modalStyles: state.appControl.modalStyles,
        floor: state.floor,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        commonLabels: state.commons,
        // styles
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentSnagDetailWithFloorMeta: (snagDetail, floorMeta) => dispatch(setCurrentSnagDetailWithFloorMeta(snagDetail, floorMeta)),
        openNewFloorModal: () => dispatch(openNewFloorModal()),
        openUploadFilesModal: () => dispatch(openUploadFilesModal()),
        openNewReportModal: () => dispatch(openNewReportModal()),
        openArchiveFloorFromProjectModal: () => dispatch(openArchiveFloorFromProjectModal()),
        archiveFloorFromProject: (userModelJson, projectModelJson, floorMapJson) => dispatch(archiveFloorFromProject(userModelJson, projectModelJson, floorMapJson)),

    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AllFloorsCard)
